webpackJsonp([12,35],{

/***/ 3:
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function (config) {
	  this.distanceX = 0;
	  this.distanceY = 0;
	  this.startPos = [0, 0];
	  this.currentPos = [0, 0];
	  this.startTime = 0;
	  this.endTime = 0;
	  this.speedX = 0;
	  this.speedY = 0;
	
	  this.state = 'FREE';
	  this.alias = config.alias || '';
	  this.dom = config.dom;
	  this.eventType = config.type || 'swipe';
	  this.callback = config.doing || function () {};
	  this.donecallback = config.done || function () {};
	
	  this.mode = config.mode || 'strict';
	
	  var t = this;
	
	  this.handleTouchStart = function (e) {
	    t.startTime = new Date().getTime();
	    t.state = 'START';
	    var touch = e.targetTouches[0];
	    t.startPos = [touch.pageX, touch.pageY];
	
	    t.callback('touchstart', {
	      distance: { x: t.distanceX, y: t.distanceY },
	      position: t.startPos,
	      state: t.state,
	      alias: t.alias
	    });
	  };
	
	  this.handleTouchMove = function (e) {
	    t.state = 'MOVING';
	    var touch = e.targetTouches[0];
	    t.currentPos = [touch.pageX, touch.pageY];
	    t.distanceX = t.currentPos[0] - t.startPos[0];
	    t.distanceY = t.currentPos[1] - t.startPos[1];
	    t.callback('touchmove', {
	      distance: { x: t.distanceX, y: t.distanceY },
	      position: t.currentPos,
	      state: t.state,
	      alias: t.alias
	    });
	  };
	
	  this.handleTouchEnd = function () {
	    t.state = 'END';
	    t.endTime = new Date().getTime();
	    var time = Math.floor((t.endTime - t.startTime) / 1000);
	
	    if (t.currentPos[0] === 0 || t.currentPos[1] === 0) {
	      t.currentPos = t.startPos;
	    }
	
	    t.distanceX = t.currentPos[0] - t.startPos[0];
	    t.distanceY = t.currentPos[1] - t.startPos[1];
	
	    if (time === 0) time = 1;
	    t.speedX = Math.abs(t.distanceX / time);
	    t.speedY = Math.abs(t.distanceY / time);
	
	    if (!t.actions[t.eventType]()) {
	      t.callback('touchend', {
	        distance: { x: t.distanceX, y: t.distanceY },
	        speed: { x: t.speedX, y: t.speedY },
	        position: t.currentPos,
	        state: t.state,
	        alias: t.alias
	      });
	    } else {
	      if (t.mode === 'unstrict') {
	        t.callback('touchend', {
	          distance: { x: t.distanceX, y: t.distanceY },
	          speed: { x: t.speedX, y: t.speedY },
	          position: t.currentPos,
	          state: t.state,
	          alias: t.alias
	        });
	      }
	
	      t.donecallback({
	        distance: { x: t.distanceX, y: t.distanceY },
	        speed: { x: t.speedX, y: t.speedY },
	        position: t.currentPos,
	        state: t.state,
	        alias: t.alias
	      });
	    }
	
	    t.state = 'FREE';
	    t.distanceX = 0;
	    t.distanceY = 0;
	    t.startTime = 0;
	    t.endTime = 0;
	    t.speedX = 0;
	    t.speedY = 0;
	    t.startPos = [0, 0];
	    t.currentPos = [0, 0];
	  };
	
	  this.actions = {
	    swipe: function swipe() {
	      return true;
	    },
	    swipeDown: function swipeDown() {
	      if (t.distanceY > 60) {
	        return true;
	      }
	      return false;
	    },
	    swipeUp: function swipeUp() {
	      if (t.distanceY < -60) {
	        return true;
	      }
	      return false;
	    },
	    swipeLeft: function swipeLeft() {
	      if (t.distanceX < -60) {
	        return true;
	      }
	      return false;
	    },
	    swipeRight: function swipeRight() {
	      if (t.distanceX > 60) {
	        return true;
	      }
	      return false;
	    },
	    swipeX: function swipeX() {
	      if (Math.abs(t.distanceX) > 60) {
	        return true;
	      }
	      return false;
	    },
	    swipeY: function swipeY() {
	      if (Math.abs(t.distanceY) > 60) {
	        return true;
	      }
	      return false;
	    }
	  };
	
	  this.init = function () {
	    this.dom.addEventListener('touchstart', this.handleTouchStart);
	    this.dom.addEventListener('touchmove', this.handleTouchMove);
	    this.dom.addEventListener('touchend', this.handleTouchEnd);
	  };
	
	  this.destory = function () {
	    this.dom.removeEventListener('touchstart', this.handleTouchStart);
	    this.dom.removeEventListener('touchmove', this.handleTouchMove);
	    this.dom.removeEventListener('touchend', this.handleTouchEnd);
	  };
	
	  this.init();
	};

/***/ }),

/***/ 47:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'slide-item',
	  props: {
	    imgUrl: String,
	    height: String,
	    width: String
	  },
	  data: function data() {
	    return {};
	  },
	
	  computed: {},
	  ready: function ready() {},
	  attached: function attached() {},
	
	  methods: {
	    handleClick: function handleClick() {}
	  },
	  components: {}
	};

/***/ }),

/***/ 48:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _touchit = __webpack_require__(3);
	
	var _touchit2 = _interopRequireDefault(_touchit);
	
	var _slideItem = __webpack_require__(52);
	
	var _slideItem2 = _interopRequireDefault(_slideItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'slide',
	  components: {
	    slideItem: _slideItem2.default
	  },
	  item: _slideItem2.default,
	  props: {
	    surface: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    ratio: {
	      type: Number,
	      default: 9 / 16
	    },
	    showStatus: {
	      type: Boolean,
	      default: true
	    },
	    width: {
	      type: String,
	      default: '100%'
	    },
	    auto: {
	      type: Boolean,
	      default: true
	    },
	    timeStep: {
	      type: Number,
	      default: 4000
	    }
	  },
	  mounted: function mounted() {
	    this.itemWidth = this.$refs.slide.clientWidth;
	
	    this.touchit = new _touchit2.default({
	      dom: this.$refs.slide,
	      type: 'swipeX',
	      done: this.goTo,
	      doing: this.sliding
	    });
	
	    if (this.auto) {
	      this.autorun();
	    }
	  },
	
	  computed: {
	    fullWidth: function fullWidth() {
	      return this.itemWidth * this.surface.length;
	    },
	    itemHeight: function itemHeight() {
	      return this.itemWidth * this.ratio;
	    }
	  },
	  methods: {
	    autorun: function autorun() {
	      var _this = this;
	
	      clearInterval(this.interval);
	      this.interval = setInterval(function () {
	        if (_this.currentIndex + 1 < _this.surface.length) {
	          _this.currentIndex += 1;
	        } else {
	          _this.currentIndex = 0;
	        }
	        _this.move(-_this.currentIndex * _this.itemWidth, false);
	        _this.preDistance = _this.distance;
	      }, this.timeStep);
	    },
	    handleClick: function handleClick(item) {
	      this.$emit('on-click', item);
	    },
	    sliding: function sliding(eventType, data) {
	      switch (eventType) {
	        case 'touchmove':
	          {
	            this.move(data.distance.x, true);
	            break;
	          }
	        case 'touchend':
	          {
	            this.fixPosition();
	            break;
	          }
	        default:
	          {
	            break;
	          }
	      }
	    },
	    goTo: function goTo(data) {
	      this.autorun();
	
	      if (data.distance.x > 0 && this.currentIndex > 0) {
	        this.currentIndex -= 1;
	      }
	
	      if (data.distance.x < 0 && this.currentIndex + 1 < this.surface.length) {
	        this.currentIndex += 1;
	      }
	
	      this.move(-this.currentIndex * this.itemWidth, false);
	
	      this.preDistance = this.distance;
	    },
	    move: function move(distance, relative) {
	      if (relative) {
	        this.distance = this.preDistance + distance;
	      } else {
	        this.distance = distance;
	      }
	      this.$refs.slidecontent.style.transform = 'translateX(' + this.distance + 'px)';
	    },
	    fixPosition: function fixPosition() {
	      this.move(-this.currentIndex * this.itemWidth, false);
	      this.preDistance = this.distance;
	    },
	    imgload: function imgload() {
	      this.itemHeight = this.height;
	    }
	  },
	  data: function data() {
	    return {
	      items: [],
	      interval: null,
	      itemWidth: 0,
	      currentIndex: 0,
	      preDistance: 0,
	      distance: 0,
	      touchit: null
	    };
	  },
	  beforeDestroy: function beforeDestroy() {
	    this.touchit.destory();
	    clearInterval(this.interval);
	  }
	};

/***/ }),

/***/ 52:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(47),
	  /* template */
	  __webpack_require__(57),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 53:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(48),
	  /* template */
	  __webpack_require__(54),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 54:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    ref: "slide",
	    staticClass: "slide",
	    style: ({
	      height: _vm.itemHeight + 'px',
	      width: _vm.width
	    })
	  }, [_c('div', {
	    ref: "slidecontent",
	    staticClass: "slide-content animate-hack",
	    style: ({
	      width: _vm.fullWidth + 'px'
	    })
	  }, [_vm._l((_vm.surface), function(item) {
	    return _c('slide-item', {
	      attrs: {
	        "imgUrl": item.imgUrl,
	        "width": (_vm.itemWidth + "px"),
	        "height": (_vm.itemHeight + "px")
	      }
	    })
	  }), _vm._v(" "), _vm._t("default")], 2), _vm._v(" "), _c('div', {
	    staticClass: "slide-btns"
	  }, _vm._l((_vm.surface), function(item, key, index) {
	    return _c('button', {
	      staticClass: "slide-btn",
	      class: [key === _vm.currentIndex ? 'slide-btn-current' : '']
	    })
	  }))])
	},staticRenderFns: []}

/***/ }),

/***/ 57:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "slide-item",
	    style: ({
	      width: _vm.width,
	      height: _vm.height,
	      'background-image': ("url(" + _vm.imgUrl + ")")
	    }),
	    on: {
	      "click": _vm.handleClick
	    }
	  })
	},staticRenderFns: []}

/***/ }),

/***/ 83:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(142),
	  /* template */
	  __webpack_require__(225),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 142:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slide = __webpack_require__(53);
	
	var _slide2 = _interopRequireDefault(_slide);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'slidedemo',
	  components: {
	    Slide: _slide2.default,
	    SlideItem: _slide2.default.item
	  },
	  data: function data() {
	    return {};
	  }
	};

/***/ }),

/***/ 225:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {}, [_c('slide', {
	    attrs: {
	      "ratio": 120 / 320,
	      "surface": [{
	          imgUrl: 'http://mlo.jishi88.com/dist/v1.3.7/2.png?870bbc643c89ab370522a8eea9cf4985'
	        },
	        {
	          imgUrl: 'http://mlo.jishi88.com/dist/v1.3.7/1.png?99a3d4cc476cce3ed4826cd912b12876'
	        },
	        {
	          imgUrl: 'http://mlo.jishi88.com/dist/v1.3.7/3.png?b13d9da72fe03c029ff79e1720a318b7'
	        }
	      ]
	    }
	  }), _vm._v(" "), _c('slide', {
	    attrs: {
	      "ratio": 120 / 320
	    }
	  }, [_c('slide-item')], 1)], 1)
	},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/12.79e5f6556de258011695.js